import React, {Component} from 'react';
import {toastr} from "react-redux-toastr";
import {Redirect} from "react-router-dom";

const LoadingScreen = () => {
    return (
        <div>
            Loading
        </div>
    )
};

const SuccessScreen = () => {
    return (
        <div>
            Success
        </div>
    )
};

const FailureScreen = () => {
    return (
        <div>
            Failure
        </div>
    )
};

class OrderConfirmation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            status: 0,
            redirect_url: null,
            redirect: false
        }
    }

    redirect_page = (url) => {
        this.setState({redirect_url: url, redirect: true})
    };


    componentDidMount() {
        const orderId = new URLSearchParams(window.location.search).get('id');
        const designId = new URLSearchParams(window.location.search).get('designId');
        const apiUrl = global.config.server_path + 'order/confirm';
        fetch(apiUrl, {method: 'POST',headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({
                id : orderId,
                paymentDetails: "DAI"
            })})
            .then(res => res.json())
            .then(res => {
                if (res.response_code !== 1) return Promise.reject("Error");
                this.setState({
                    status: 1
                });
                toastr.success("Success");
                this.redirect_page("/designmaker/start/designs/"+designId+"/edit");
            })
            .catch(err => {
                this.setState({
                    status: 1
                });
                toastr.error("Payment Failed");
                this.redirect_page("/designmaker/start/designs/"+designId+"/edit");
            })
    }

    render() {

        let {redirect, redirect_url} = this.state;

        if (redirect) {
            return (<Redirect push to={redirect_url}/>)
        }

        switch (this.state.status) {
            case 0:
                return (<LoadingScreen/>);
            case 1:
                window.top.postMessage('orderPaymentSuccess', '*');
                return (<SuccessScreen/>);
            case -1:
                return (<FailureScreen/>);
        }
    }
}

export default OrderConfirmation;